import {
  RecommendedUsersSortOptionEnum,
  FilterApplicantsByGeographicalLimitEnum,
  OpeningPotentialCandidatesForSourcePageCarouselQueryVariables,
  OpeningsQueryVariables,
} from '@src/graphql/generated';
import { QueryParams } from '@src/containers/Source/interfaces/queryParams.interface';
import { GroupedTalentDictionaryKey } from '@src/containers/Source/constants/groupedTalentDictionary/enums/groupedTalentDictionaryKey.enum';
import { DEFAULT_CURRENCY_CODE } from '@src/constants';

export const getOpeningRecommendedUsersVariables = (
  queryParams: QueryParams & {
    excludedUserIds?: string[];
    openingId?: string;
    recruiterCurrencyCode?: string;
  },
): OpeningPotentialCandidatesForSourcePageCarouselQueryVariables | OpeningsQueryVariables => {
  if (queryParams.openingId) {
    return {
      excludedUserIds: queryParams.excludedUserIds,
      filters: {
        ...(queryParams.isLocal
          ? {
              geographicalLimit: {
                type: FilterApplicantsByGeographicalLimitEnum.OPENING_NEARBY_LOCATIONS,
              },
            }
          : {}),
        ...(queryParams.isRelocation ? { isRelocation: true } : {}),
        ...(queryParams.isRemote ? { isRemote: true } : {}),
      },
      openingId: queryParams.openingId,
      paginationOptions: {
        limit: 12,
        sortBy:
          queryParams.groupedTalentsKey === GroupedTalentDictionaryKey.RECENTLY_JOINED
            ? RecommendedUsersSortOptionEnum.JOINED_AT
            : RecommendedUsersSortOptionEnum.RELEVANCE,
      },
      recruiterCurrencyCode: queryParams.recruiterCurrencyCode || DEFAULT_CURRENCY_CODE,
    };
  }

  return {
    filters: {
      ...(queryParams.isLocal
        ? {
            geographicalLimit: {
              type: FilterApplicantsByGeographicalLimitEnum.OPENING_NEARBY_LOCATIONS,
            },
          }
        : {}),
      ...(queryParams.isRelocation ? { isRelocation: true } : {}),
      ...(queryParams.isRemote ? { isRemote: true } : {}),
    },
    paginationOptions: {
      limit: 12,
      sortBy: RecommendedUsersSortOptionEnum.RELEVANCE,
    },
    recruiterCurrencyCode: queryParams.recruiterCurrencyCode || DEFAULT_CURRENCY_CODE,
  };
};
